import { InputText } from "primereact/inputtext";
import { InputLabel } from "./InputLabel";

const TextInputField = ({
  name,
  label,
  value,
  onChange,
  errorMessage,
  containerClassName = "field col-12 md:col-6",
  inputClassName = "input-field",
  required = false,
}) => {
  return (
    <div className={containerClassName}>
      <InputLabel
        name={name}
        label={label}
        required={required}
        errorMessage={errorMessage}
      />

      <InputText
        id={name}
        value={value}
        onChange={onChange}
        className={inputClassName}
        required={required}
      />
    </div>
  );
};

export default TextInputField;
